import { render } from "./OpenRatings.vue?vue&type=template&id=036fb273&ts=true"
import script from "./OpenRatings.vue?vue&type=script&lang=ts"
export * from "./OpenRatings.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__